import React, { useEffect, useState } from "react";
import instance from "../axios/global";
import ClientMonthlyTotals from "../components/ClientMonthlyTotals";
import { formatAmount } from "../components/ClientSummaryTable";
import LoaderComp from "../components/LoaderComp";
import NavClient from "../components/NavClient";

const GlobalClients = () => {
  const [summary, setSummary] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    instance.get("/client/all/summary")
      .then(({ data }) => { if (active) setSummary(data); })
      .catch(() => { if (active) setError("Impossible de charger les clients."); });
    return () => { active = false; };
  }, []);

  return (
    <div className="container-all-clients">
      <h1>Clients</h1>
      <div className="div-total-create-client">
        <NavClient />
        <div className="descrip-totals" style={{ flexDirection: "column" }}>
          <p>Total bons de commande attribué</p>
          <span>{summary ? formatAmount(summary.grandTotal) : "—"}</span>
        </div>
      </div>
      {error ? <p role="alert">{error}</p> : !summary ? <LoaderComp /> : (
        <div>
          <span className="total-mois">Total par mois</span>
          <ClientMonthlyTotals months={summary.months} totalsByMonth={summary.totalsByMonth} />
        </div>
      )}
    </div>
  );
};

export default GlobalClients;
